<!-- Payment failure.
     Deliberately not styled as an alert banner: the member has just been
     interrupted mid-purchase, so the page leads with what happened and what to
     do next, and keeps the provider's error code out of the way at the bottom
     for support to quote. -->
<div class="checkout-failure">
  <div class="checkout-failure__card" role="alert" aria-labelledby="checkout-failure-title">
    <!-- Drawn rather than an icon font: the two strokes are animated
         separately so the ring draws itself and the cross lands after it,
         which reads as a considered result rather than a warning that was
         already sitting there. -->
    <svg class="checkout-failure__mark" viewBox="0 0 84 84" aria-hidden="true" focusable="false">
      <circle class="checkout-failure__mark-halo" cx="42" cy="42" r="40" />
      <circle class="checkout-failure__mark-ring" cx="42" cy="42" r="31" fill="none" stroke-width="2.5" />
      <path class="checkout-failure__mark-cross" d="M31.5 31.5 52.5 52.5" stroke-width="3" stroke-linecap="round" />
      <path class="checkout-failure__mark-cross checkout-failure__mark-cross--second" d="M52.5 31.5 31.5 52.5" stroke-width="3" stroke-linecap="round" />
    </svg>

    <h1 class="checkout-failure__title" id="checkout-failure-title">{{ reason().title }}</h1>
    <p class="checkout-failure__message">{{ reason().message }}</p>

    <!-- Reassurance sits above the actions, because "have I been charged?" is
         the first thing a member wants answered and the buttons are useless
         until it is. -->
    <p class="checkout-failure__assurance">
      <span class="material-icons checkout-failure__assurance-icon" aria-hidden="true">lock</span>
      <span>Your card has not been charged and your basket has been kept.</span>
    </p>

    <div class="checkout-failure__actions">
      <!-- Primary action depends on the cause: where the same card could
           plausibly work the member is offered a straight retry, and where it
           cannot the wording sends them to a different card instead. Both go
           to the same place - the difference is what the member is told to
           expect, not where they land. -->
      <button type="button" class="checkout-failure__button checkout-failure__button--primary" (click)="tryAgain()">
        @if (reason().canRetry) {
          Try payment again
        } @else {
          Use a different card
        }
      </button>

      <a class="checkout-failure__button checkout-failure__button--ghost" routerLink="/rewards">Back to rewards</a>
    </div>

    <!-- Only rendered when the provider actually gave a code. An empty
         "Reference:" line would look like something failed to load. -->
    @if (reasonId()) {
      <p class="checkout-failure__reference">
        Reference code <span class="checkout-failure__reference-code">{{ reasonId() }}</span>
      </p>
      <p class="checkout-failure__support">Quote this code if you contact support and they can look up exactly what happened.</p>
    }
  </div>
</div>
